import React, { useEffect, useState } from "react";
import { appTheme } from "../../../helpers/utils/Utils";
import { useSelector } from "react-redux";
const CardHeading = ({ heading, headingWithimage, image, isWhite, imageEnd,endBtn,endBtnText,headerButtonClick }) => {
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue)
    return (
        <>

            {headingWithimage ? <div className=' 
                                 md:my-[41px] sm:my-[20px] my-[20px] md:mx-[7%]
                                 sm:ml-[7%] sm:mr-[8%]
                                 mr-[2.5rem] ml-[2.5rem] text-[var(--text-clr-transactions)]  
                                    md:font-[500] sm:font-[600] font-[500] lg:text-[26px]
                                     md:text-[26px] sm:text-[15px] text-[16px] 
                                     font-hanken-grotesk 
                                    sm:mx-0 mx-4'>
                {headingWithimage}
            </div> :
                <div className={`sm:flex block justify-between flex-nowrap items-center 
                                 md:my-[41px] sm:my-[20px] my-[20px] md:mx-[7%]
                                 sm:ml-[7%] sm:mr-[8%]
                                 mr-[2.5rem] ml-[2.5rem] ${isWhite ? 'text-white' : 'text-[var(--text-clr-transactions)] '}  
                                    md:font-[500] sm:font-[600] font-[500] lg:text-[26px]
                                     md:text-[26px] sm:text-[15px] text-[16px] 
                                     font-hanken-grotesk 
                                    sm:mx-0 mx-4`}>
                    <div className={`${imageEnd || endBtn ? 'justify-between w-full' : ' gap-2'} flex items-center`}>

                        {image && !imageEnd && !endBtn && (
                            <div>
                                <img src={image} alt={image} />
                            </div>
                        )} {heading}

                        {imageEnd && (<div>
                            <img src={image} alt={image} className='w-8 h-8'/>  
                        </div>
                        )}

                        {endBtn && (<button type="button" className="flex  items-center justify-center rounded-full
                         lg:w-[165px] md:w-[150px] sm:w-[100px] w-[96px] lg:h-[55px] md:h-[50px] 
                         sm:h-[34px] h-[34px] bg-gradient-to-r from-[#2965FB] via-[#4B70B9]
                          to-[#30BC89] p-[2px] text-white  lg:text-[16px] md:text-[18px]
                           sm:text-[11px] text-[14px] md:leading-[46.09px] sm:leading-[22.8px] 
                           leading-[26px]  text-[#ffff] font-[700] font-hanken-grotesk"
                           onClick={()=> headerButtonClick()}
                            style={{
                                background: "linear-gradient(141deg, #2965FB, #4B70B9, #30BC89)",
                                border: "2px solid transparent",
                                borderRadius: "9999px",
                                backgroundClip: "padding-box",
                                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)"
                            }}>
                            <div className="flex h-full items-center justify-center rounded-full w-full
                             bg-[#324261]">
                               {endBtnText}
                            </div>
                        </button>
                        )}

                    </div>
                </div>}


        </>
    );
};

export default CardHeading;